'use client';

import Link from 'next/link';
import { Home, ArrowLeft } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { log404Error } from './actions/log-404';

export default function NotFound() {
  const pathname = usePathname();
  const hasLogged = useRef(false);

  useEffect(() => {
    if (!hasLogged.current && pathname) {
      const referrer = typeof document !== 'undefined' ? document.referrer : '';
      log404Error(pathname, referrer);
      hasLogged.current = true;
    }
  }, [pathname]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-16">
      <div className="bg-[var(--bg-elevated)] p-8 md:p-12 rounded-2xl shadow-sm border border-[var(--color-border)] max-w-lg w-full">
        <h1 className="text-8xl font-bold text-[var(--color-primary)] mb-4">404</h1>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--text-primary)] mb-4">
          Page Not Found
        </h2>
        <p className="text-[var(--color-text-muted)] mb-8 text-lg">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            href="/"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-[var(--color-primary)] text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
          >
            <Home size={18} />
            Go to Homepage
          </Link>
          <Link 
            href="/articles"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-[var(--bg-base)] border border-[var(--color-border)] text-[var(--text-primary)] rounded-lg font-medium hover:bg-[var(--bg-secondary)] transition-colors"
          >
            <ArrowLeft size={18} />
            Browse Articles
          </Link>
        </div>
      </div>
    </div>
  );
}
